export default {"src":"/_next/static/media/cet_g.409a5ce3.svg","height":445,"width":721};